import {
  permission,
  userColumn,
  userFilter,
  filterUserTypeOption
} from './permission';

function installPermission(Vue, resp) {
  Vue.prototype.role = resp.type == '8' ? 'person' : resp.role;
  Vue.prototype.isPerson = resp.type == '8';
  Vue.prototype.seeRight =
    resp.type == '8' ||
    resp.role == 'root' ||
    resp.role == 'customer' ||
    resp.role == 'bigcustomer'
      ? false
      : true;
  Vue.prototype.userId = resp.userid;
  if (Vue.prototype.isPerson) {
    Vue.prototype.permissions = permission['person'];
  } else {
    Vue.prototype.permissions = permission[resp.role];
    Vue.prototype.userColumns = userColumn[resp.role];
    Vue.prototype.userFilters = userFilter[resp.role];
    Vue.prototype.filterUserTypeOptions = filterUserTypeOption[resp.role];
  }
  //判断是否钉钉接入
  Vue.prototype.isDingTalk = resp.isDtUser ? true : false;
}
export default installPermission;



// WEBPACK FOOTER //
// ./src/common/installPermission.js